import React from 'react';
import TrainingPortal from '../components/training/TrainingPortal';

const TrainingPortalPage = () => {
  return <TrainingPortal />;
};

export default TrainingPortalPage;